/* eslint-disable camelcase */
import { useEffect, useState } from 'react';
import { IConfigEntityLinks, ISeasonsDetailsResponse, SDKOptions } from '../../../../../packages/types';
import { getStages } from '../../../../../packages/services/football/common';
import { normalizeTournamentStages } from '../../normalizers/round/normalizeTournamentStagesResponseData';

interface IUseTournamentStage {
  tournamentId?: string;
  seasonId?: string;
  sdkOptions: SDKOptions;
  dataEntityLinks?: IConfigEntityLinks | null;
  stageId?: string;
}

export default function useTournamentStages({ tournamentId, seasonId, stageId, sdkOptions, dataEntityLinks }: IUseTournamentStage) {
  const [stages, setStages] = useState<ISeasonsDetailsResponse>();

  const params = {
    tournament_id: tournamentId,
    season_id: seasonId,
  };

  useEffect(() => {
    getStages({ params, sdkOptions })
      ?.then(({ season, stages }) => {
        setStages({ season, stages });
      })
      .catch((error: unknown) => {
        console.error(error);
      });
  }, [tournamentId, seasonId]);

  const { tournament, activeStage, activeRound, rounds } = normalizeTournamentStages({ ...stages, stageId, dataEntityLinks });

  return {
    tournament,
    activeStage,
    activeRound,
    rounds,
  };
}
